import React, { useRef } from "react";
import { FormControl, Card, Layout, Button, usePath, useAppConfig } from "@fdoh/health-ui-react";
import { useHistory, Link } from "react-router-dom";
import { useSubmitForm } from "../../hooks/useSubmitForm";
import { useForm } from "react-hook-form";
import { FillExcavationMaterialInput, schema, FillExcavationMaterialFormProps, ComplianceData } from "./FillExcavationMaterialForm.types";
import { useData } from "../../hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import CSS from 'csstype';
import { Constants, InspectionStatus } from "../../helpers/Constants";
import { toast } from "react-toastify";
import { InspectionStatusInput } from "../InspectionHome/InspectionHome.types";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";

export const FillExcavationMaterialForm = (props: FillExcavationMaterialFormProps) => {
    const history = useHistory();
    const path = usePath();
    const complianceData = useData<ComplianceData[]>("Compliance") || [];
    const aboveBelowData = [
        { id: "", name: "Select Above or Below" },
        { id: "Above", name: "Above" },
        { id: "Below", name: "Below" }
    ];
    const { control, handleSubmit, setValue, watch } = useForm<FillExcavationMaterialInput>({
        resolver: yupResolver(schema),
        defaultValues: props.values as any,
    });
    const config =  useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
         const user =  useProfile(application) as UserSecurityInput;
    const inspectionStatusData = useData<InspectionStatusInput>("inspectionDetails/" + props.applicationInspectionId);
    const formRef = useRef<HTMLFormElement>(null);

    function timeout(delay: number) {
        return new Promise(res => setTimeout(res, delay));
    }
    
    const onSubmit = useSubmitForm<FillExcavationMaterialInput>(
        'FillExcavationMaterial',
        async (response) => {
            toast.success("Fill Excavation Material Saved Successfully");
            await timeout(2000);
            let inspectionStatus = watch("inspectionStatusId");
            if(inspectionStatus == InspectionStatus.Complete){
                if(inspectionStatusData?.setBackInspectionId == null 
                    || inspectionStatusData?.setBackInspectionId == undefined){
                        history.push({
                            pathname: "/setbacks/",
                            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                        })
                    }
                    else {
                        history.push({
                            pathname: "/setbacks/"+ inspectionStatusData?.setBackId,
                            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                            
                        })
                    }
            }
            else if (inspectionStatus == InspectionStatus.Incomplete){
                history.push(`/inspectionDetails/${inspectionStatusData?.applicationInspectionId}`) ;
            }
           

        },
        props.action
    );


    const submit = () => {
        setValue('applicationId', props.applicationId ? props.applicationId : 0);
        setValue('applicationInspectionId', props.applicationInspectionId ? props.applicationInspectionId : 0);
        if(inspectionStatusData?.fillExcavationMaterialInspectionId == null 
            || inspectionStatusData?.fillExcavationMaterialInspectionId == undefined){
                setValue('dateCreated', new Date());
                setValue('createdBy', user?.userName);
            }
            else {
                setValue('dateUpdated', new Date());
                setValue('updatedBy', user?.userName);
            }
        if (formRef.current) {

            formRef.current.dispatchEvent(
                new Event('submit', { cancelable: true, bubbles: true })
            );

        }
    }

   


    let showMediaLayer1Comment = watch("mediaLayer1ComplianceId");
    let showMediaLayer2Comment = watch("mediaLayer2ComplianceId");
    let showExcavationDepthComment = watch("excavationDepthComplianceId");
    let showReplacementMaterialComment = watch("replacementMaterialComplianceId");
    let markAllCompliance = watch("markAll");

    const markClick = (e: any) => {
            setValue('mediaLayer1ComplianceId', markAllCompliance);
            setValue('mediaLayer2ComplianceId', markAllCompliance);
            setValue('excavationDepthComplianceId', markAllCompliance);
            setValue('replacementMaterialComplianceId', markAllCompliance);
            
            e.preventDefault();
    };


    const h1Styles: CSS.Properties = {
        float: "right",
       marginTop: '27px'
      };
    const Ctitle: CSS.Properties = {
        fontSize: "32px",
        marginTop: "20px",
        marginBottom: "0px",
        color: "#134076",
    }
    const controlInline: CSS.Properties ={
        display: "flex",
        whiteSpace: "nowrap"
    }
    

    return (
        <form ref={formRef} onSubmit={handleSubmit((data: FillExcavationMaterialInput) => onSubmit(data))}>
            <div className="row">
                <div className="col col-md-8">
                    <div className="card-main-title">
                        Fill/Excavation Material
                    </div>                    
                </div>
                <div className="col col-md-3">
                    <FormControl.Select
                        control={control}
                        name="markAll"
                        label="Mark All"
                        options={complianceData}
                        style={controlInline}
                        required
                    />
                </div>
                <div className="col col-md-1" style={h1Styles}>
                    <Button name="markAll" className="btn btn-primary" onClick={markClick} >Apply</Button>
                </div>
            </div>
            <Card.Container>

                <Card.Header>
                    <Card.Title>{props.title}</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Layout.Row>   <>
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="mediaLayer1ComplianceId"
                                    label="Media Layer 1"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showMediaLayer1Comment &&
                            showMediaLayer1Comment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="mediaLayer1Comment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="mediaLayer2ComplianceId"
                                    label="Media Layer 2"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-3">
                                <FormControl.Text
                                    control={control}
                                    name="bottomOfMediaLayer2"
                                    label="Bottom of Media Layer 2 (in.)"
                                    required= {showMediaLayer2Comment != Constants.Not_Applicable && showMediaLayer2Comment !=Constants.Unobserved }
                                />
                            </div>
                            <div className="col col-md-3">
                                <FormControl.Select
                                    control={control}
                                    name="aboveBelowBenchmark"
                                    label="Above/Below Benchmark"
                                    options={aboveBelowData}
                                    required= {showMediaLayer2Comment != Constants.Not_Applicable && showMediaLayer2Comment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showMediaLayer2Comment &&
                            showMediaLayer2Comment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="mediaLayer2Comment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="excavationDepthComplianceId"
                                    label="Excavation"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-2">
                                <FormControl.Text
                                    control={control}
                                    name="depthInFeet"
                                    label="Depth (D in feet)"
                                    required= {showExcavationDepthComment != Constants.Not_Applicable && showExcavationDepthComment !=Constants.Unobserved }
                                />
                            </div>
                            <div className="col col-md-2">
                                <FormControl.Text
                                    control={control}
                                    name="lengthInFeet"
                                    label="Length (L in feet)"
                                    required= {showExcavationDepthComment != Constants.Not_Applicable && showExcavationDepthComment !=Constants.Unobserved }
                                />
                            </div>
                            <div className="col col-md-2">
                                <FormControl.Text
                                    control={control}
                                    name="widthInFeet"
                                    label="Width (W in feet)"
                                    required= {showExcavationDepthComment != Constants.Not_Applicable && showExcavationDepthComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showExcavationDepthComment &&
                            showExcavationDepthComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="excavationDepthComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="replacementMaterialComplianceId"
                                    label="Fill / Replacement Material"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4" hidden>
                                <FormControl.Text
                                    control={control}
                                    name="createdBy"
                                    label="Created By"
                                    required
                                />
                            </div>
                            <div className="col col-md-4" hidden>
                                <FormControl.Text
                                    control={control}
                                    name="applicationId"
                                    label="application id"
                                    required
                                />
                            </div>
                        </div>
                        {showReplacementMaterialComment &&
                            showReplacementMaterialComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="replacementMaterialComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="row">
                           
                            <div className="col col-md-4" hidden>
                                <FormControl.Text
                                    control={control}
                                    name="inspectionStatusId"
                                    label="Created By"
                                    required
                                />
                                <FormControl.Hidden
                                    control={control}
                                    name="applicationInspectionId"
                                    required
                                />
                            </div>  
                        </div>

                    </>
                    </Layout.Row>
                </Card.Body>
                <Card.Footer>
                    <div className="d-flex">
                        <span className="btn btn-link" onClick={(e) => {
                            e.preventDefault();
                            setValue('inspectionStatusId', InspectionStatus.Incomplete);
                            submit()

                        }}> <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-arrow-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"></path>
                                <path d="M8 12l4 4"></path><path d="M8 12h8"></path>
                                <path d="M12 8l-4 4"></path>
                            </svg> Save and Exit
                        </span>                       
                        <div className="btn-list ms-auto">
                            <Link
                                to={props.returnPath}
                                className="btn btn-light"
                                role="button"
                            >
                                Cancel
                            </Link>
                            <Button className="btn btn-primary ms-auto" onClick={(e) => {
                                e.preventDefault();
                                setValue('inspectionStatusId', InspectionStatus.Complete);
                                submit()

                            }}>Next</Button>
                        </div>                        
                    </div>
                </Card.Footer>
            </Card.Container>
        </form>
    );
};
export default FillExcavationMaterialForm;
